
      /* ============ Shopify: sin router SPA ============
       Cada pagina es su propio URL; el <main> ya viene con class
       "page active". Solo queda marcar el enlace activo del menu
       segun la ruta actual y el aviso de diseno en Cotizar. */
      var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      (function(){
        var path = location.pathname.replace(/\/$/, '') || '/';
        document.querySelectorAll('#mainNav a').forEach(function(a){
          var href = a.getAttribute('href') || '';
          var hp = href.replace(/\/$/, '') || '/';
          a.classList.toggle('active', hp === path);
        });
        var dn = document.getElementById('designNote');
        if (dn && document.getElementById('page-cotizar') && !dn.classList.contains('gone')){
          setTimeout(function(){ dn.classList.add('show'); }, 300);
        }
        var an = document.getElementById('apartadoNote');
        if (an && document.getElementById('page-cotizar') && !an.classList.contains('gone')){
          setTimeout(function(){ an.classList.add('show'); }, 300);
        }
      })();


      /* ============ data ============ */
      var MATERIALS = {
        pla:    {name:'PLA',          priceKg:450, density:1.24},
        petg:   {name:'PETG',         priceKg:560, density:1.27},
        tpu95:  {name:'TPU 95A',      priceKg:720, density:1.21},
        tpu64:  {name:'TPU 64D–75D',  priceKg:760, density:1.25},
        placf:  {name:'PLA-CF',       priceKg:850, density:1.30},
        petgcf: {name:'PETG-CF',      priceKg:900, density:1.30}
            };
      var MACHINE_RATE = 22;
      var PREP_FEE = 60;
      var MARGIN = 1.5;

      /* ============ Tendencias 12 + quick-view ============ */
      var TREND_PRODUCTS = [
        {id:'caja', name:'Caja Plegable', tag:'Personalizable', price:19, colors:['Negro','Blanco','Café'], customText:true,
         desc:'Caja plegable que se arma en segundos. Pide el texto que quieras, va incluido.',
         detail:'Caja plegable impresa en PLA. Se arma y se pliega fácil, ideal para guardar y regalar. El texto personalizado va incluido: pide el que quieras. Medida por confirmar.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p01-main.png?v=1792129982','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p01-2.png?v=1792130012','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p01-3.png?v=1792130022','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p01-4.png?v=1792130030']},
        {id:'hisopos', name:'Porta Hisopos', tag:'En tendencia', price:249, colors:['Negro','Blanco','Café'],
         desc:'Porta hisopos con tapa. 14 cm de altura.',
         detail:'Porta hisopos en PLA, con tapa. Mide 14 cm de altura. Sin personalización. Perfecto para baño y tocador.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p02-main.webp?v=1792130038','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p02-2.png?v=1792130047','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p02-3.png?v=1792130055','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p02-4.png?v=1792130064']},
        {id:'controles', name:'Organizador de Controles', tag:'2 tamaños', price:249, colors:['Negro','Blanco','Café'],
         sizes:[{label:'Grande · 4 espacios', price:249},{label:'Chico · 2 espacios', price:149}],
         desc:'Organizador para controles de TV. Grande 4 espacios o chico 2 espacios.',
         detail:'Organizador de controles en PLA, con dos tamaños: grande con 4 espacios y chico con 2 espacios. Sin medidas: como se ve y lo que le quepa.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p03-main.webp?v=1792130074','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p03-2.png?v=1792130082','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p03-3.png?v=1792130092','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p03-4.png?v=1792130100','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p03-5.png?v=1792130107']},
        {id:'rollo', name:'Porta Rollo de Cocina', tag:'En tendencia', price:349, colors:['Negro','Blanco','Café'],
         desc:'Para rollo de cocina de papel estándar.',
         detail:'Porta rollo de cocina en PLA. Cabe rollo de cocina de papel estándar. Sin medida adicional.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p04-main.webp?v=1792130115','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p04-2.png?v=1792130124','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p04-3.png?v=1792130133']},
        {id:'ganchos', name:'Ganchos de Pared', tag:'Combinables', price:49, colors:['Negro','Blanco','Café'],
         dual:{label1:'Color de la tapa', label2:'Color de la base'},
         desc:'Ganchos de pared plegables. Combina 2 colores: tapa de uno y base de otro.',
         detail:'Ganchos de pared en PLA, plegables. Puedes combinar 2 colores entre negro, blanco y café: la tapa de un color y la otra parte de otro. Sin medidas.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p05-main.webp?v=1792130141','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p05-2.png?v=1792130149','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p05-3.png?v=1792130157']},
        {id:'utensilios', name:'Porta Utensilios', tag:'2 tamaños', price:599, colors:['Negro','Blanco','Café'],
         sizes:[{label:'Grande · 17 cm', price:599},{label:'Chico · 15 cm', price:399}],
         desc:'Porta utensilios de cocina. Grande 17 cm o chico 15 cm.',
         detail:'Porta utensilios de cocina en PLA, con dos tamaños: grande de 17 cm y chico de 15 cm. Para cucharas, palas, batidores y más.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p06-main.webp?v=1792130165','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p06-2.png?v=1792130173','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p06-3.png?v=1792130180']},
        {id:'soporte', name:'Soporte para Celular', tag:'Llavero', price:19, colors:['Blanco','Negro','Azul','Amarillo','Rosa','Café'],
         desc:'Soporte plegable para celular, tipo llavero.',
         detail:'Soporte plegable para celular en PLA, tipo llavero: lo llevas en las llaves y lo usas donde quieras. Disponible en blanco, negro, azul, amarillo, rosa y café.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p07-main.webp?v=1792130186','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p07-2.png?v=1792130194','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p07-3.png?v=1792130202']},
        {id:'portavelas', name:'Portavelas', tag:'Decoración', price:49, colors:['Negro','Blanco','Café'],
         desc:'Portavelas cuadrado para vela LED.',
         detail:'Portavelas en PLA para vela LED. Decoración cálida para mesa, sala o recámara.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p08-main.webp?v=1792130210','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p08-2.png?v=1792130219','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p08-3.png?v=1792130229']},
        {id:'bandeja', name:'Bandeja Decorativa', tag:'2 colores', price:299, colors:['Negro','Blanco','Café'],
         dual:{label1:'Color de la mesa', label2:'Color de las patitas'},
         desc:'Bandeja decorativa redonda. Elige un color para la mesa y otro para las patitas.',
         detail:'Bandeja decorativa en PLA. Eliges 2 colores: uno para la mesa y otro para las patitas, entre negro, blanco y café.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p09-main.webp?v=1792130237','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p09-2.png?v=1792130246','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p09-3.png?v=1792130254']},
        {id:'cafe', name:'Dispensador de Café', tag:'En tendencia', price:499, colors:['Negro','Blanco','Café'],
         desc:'Dispensador de café con dosificador.',
         detail:'Dispensador de café en PLA, con dosificador. Para tener el café a la mano en tu cocina o barra.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p10-main.webp?v=1792130264','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p10-2.png?v=1792130272']},
        {id:'envase', name:'Envase Dispensador', tag:'Solo envase', price:299, colors:['Negro','Blanco','Café'],
         desc:'Envase para jabón o loción. No incluye el dispensador, es solo el envase.',
         detail:'Envase dispensador en PLA para jabón, loción o gel. Importante: NO incluye el dispensador o bomba, es solo el envase.',
         note:'NO incluye el dispensador/bomba, es solo el envase.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p11-main.webp?v=1792130280','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p11-2.png?v=1792130289','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p11-3.png?v=1792130298']},
        {id:'viaje', name:'Contenedor de Viaje', tag:'Viaje', price:99, colors:['Negro','Blanco'],
         desc:'Para guardar diferentes cosas en tu viaje. Tapa de rosca.',
         detail:'Contenedor de viaje en PLA, con tapa de rosca. Para guardar diferentes cosas: algodón, pastillas, accesorios y más.',
         imgs:['https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p12-main.webp?v=1792130308','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p12-2.png?v=1792130315','https://cdn.shopify.com/s/files/1/1017/3041/9051/files/trend-p12-3.png?v=1792130323']}
      ];
      var PRODUCTS = TREND_PRODUCTS;
      function money(n){ return '$' + Math.round(n).toLocaleString('es-MX'); }
      function trendVolPct(qty){ if (qty >= 50) return 0.15; if (qty >= 25) return 0.10; if (qty >= 5) return 0.05; return 0; }
      function trendUnit(p){ return (p.sizes ? p.sizes[qv.sizeIdx || 0].price : p.price); }
      function trendCalc(p){
        var qty = Math.max(1, Math.round(qv.qty || 1));
        var unit = trendUnit(p);
        var pct = trendVolPct(qty);
        var gross = unit * qty;
        var disc = Math.round(gross * pct);
        var total = gross - disc;
        var discUnit = qty > 0 ? total / qty : unit;
        return {qty: qty, unit: unit, pct: pct, gross: gross, disc: disc, total: total, discUnit: discUnit};
      }
      function productCard(p, withBuy){
        var priceTxt = p.sizes ? ('desde ' + money(p.sizes[1].price)) : money(p.price);
        return '<article class="prod"><div class="ph" data-card-id="' + p.id + '" onclick="openQuick(\'' + p.id + '\')" role="button" tabindex="0" aria-label="Ver ' + p.name + '" onkeydown="if(event.key===\'Enter\')openQuick(\'' + p.id + '\')"><img data-card-img="' + p.id + '" data-idx="0" src="' + p.imgs[0] + '" alt="' + p.name + ' impreso en 3D" loading="lazy" /></div><div class="body">' +
          '<h3>' + p.name + '</h3><p>' + p.desc + '</p>' +
          '<div class="price">' + priceTxt + ' <small>MXN</small></div>' +
          (withBuy ? '<button class="btn block sm" onclick="openQuick(\'' + p.id + '\')">Ver opciones</button>' : '') +
          '</div></article>';
      }
      /* ============ quick-view ============ */
      var qv = {id: null, sizeIdx: 0, color: '', color2: '', text: '', qty: 1, imgIdx: 0};
      function qvProduct(){ return TREND_PRODUCTS.filter(function(x){ return x.id === qv.id; })[0] || null; }
      function openQuick(id){
        var p = TREND_PRODUCTS.filter(function(x){ return x.id === id; })[0];
        if (!p) return;
        qv = {id: id, sizeIdx: 0, color: p.colors[0], color2: p.dual ? p.colors[1] : '', text: '', qty: 1, imgIdx: 0};
        var ov = document.getElementById('qvOverlay'), w = document.getElementById('qvWrap');
        if (ov) ov.hidden = false;
        if (w) w.hidden = false;
        document.body.classList.add('qv-open');
        if (typeof stopAllCardRot === 'function') stopAllCardRot();
        renderQV();
        if (typeof startQvRot === 'function') startQvRot();
        var c = document.getElementById('qvClose');
        if (c) c.focus();
      }
      function closeQuick(){
        var ov = document.getElementById('qvOverlay'), w = document.getElementById('qvWrap');
        if (ov) ov.hidden = true;
        if (w) w.hidden = true;
        document.body.classList.remove('qv-open');
        if (typeof stopQvRot === 'function') stopQvRot();
        if (typeof startAllCardRot === 'function') startAllCardRot();
      }
      function qvSetImg(i){
        qv.imgIdx = i;
        var p = qvProduct(); if (!p) return;
        var img = document.getElementById('qvImg');
        if (img){ img.src = p.imgs[i]; img.alt = p.name + ' impreso en 3D'; }
        document.querySelectorAll('#qvThumbs img').forEach(function(t, idx){ t.classList.toggle('sel', idx === i); });
      }
      function renderQV(){
        var p = qvProduct(); if (!p) return;
        var t = document.getElementById('qvTag'); if (t) t.textContent = p.tag;
        var ti = document.getElementById('qvTitle'); if (ti) ti.textContent = p.name;
        var de = document.getElementById('qvDesc'); if (de) de.textContent = p.detail;
        var no = document.getElementById('qvNote');
        if (no){ if (p.note){ no.textContent = p.note; no.hidden = false; } else no.hidden = true; }
        var sw = document.getElementById('qvSizeWrap');
        if (sw){
          if (p.sizes){
            sw.hidden = false;
            document.getElementById('qvSizes').innerHTML = p.sizes.map(function(s, i){
              return '<button type="button" class="chip' + (qv.sizeIdx === i ? ' sel' : '') + '" onclick="qvPickSize(' + i + ')">' + s.label + ' · ' + money(s.price) + '</button>';
            }).join('');
          } else sw.hidden = true;
        }
        var cw = document.getElementById('qvColorWrap');
        if (cw){
          var cl = document.getElementById('qvColorLabel');
          if (cl) cl.textContent = p.dual ? p.dual.label1 : 'Color';
          document.getElementById('qvColors').innerHTML = p.colors.map(function(c){
            return '<button type="button" class="chip' + (qv.color === c ? ' sel' : '') + '" onclick="qvPickColor(\'' + c + '\')">' + c + '</button>';
          }).join('');
        }
        var c2w = document.getElementById('qvColor2Wrap');
        if (c2w){
          if (p.dual){
            c2w.hidden = false;
            var c2l = document.getElementById('qvColor2Label');
            if (c2l) c2l.textContent = p.dual.label2;
            document.getElementById('qvColors2').innerHTML = p.colors.map(function(c){
              return '<button type="button" class="chip' + (qv.color2 === c ? ' sel' : '') + '" onclick="qvPickColor2(\'' + c + '\')">' + c + '</button>';
            }).join('');
          } else c2w.hidden = true;
        }
        var tw = document.getElementById('qvTextWrap');
        if (tw){
          tw.hidden = !p.customText;
          var ti2 = document.getElementById('qvText');
          if (ti2 && !p.customText) ti2.value = '';
        }
        var th = document.getElementById('qvThumbs');
        if (th) th.innerHTML = p.imgs.map(function(u, i){
          return '<img src="' + u + '" alt="" onclick="qvManualImg(' + i + ')" class="' + (i === qv.imgIdx ? 'sel' : '') + '" />';
        }).join('');
        var img = document.getElementById('qvImg');
        if (img){ img.src = p.imgs[qv.imgIdx]; img.alt = p.name + ' impreso en 3D'; }
        var qEl = document.getElementById('qvQty');
        if (qEl){
          // No pisar lo que el cliente está tecleando: solo sincronizar cuando el campo no tiene el foco.
          if (document.activeElement !== qEl) qEl.value = qv.qty;
        }
        var c = trendCalc(p);
        var uEl = document.getElementById('qvUnit'); if (uEl) uEl.textContent = money(c.unit) + ' MXN';
        var dr = document.getElementById('qvDiscRow');
        if (dr){
          dr.hidden = !(c.pct > 0);
          var dl = document.getElementById('qvDisc'); if (dl) dl.textContent = '−' + money(c.disc) + ' MXN (' + Math.round(c.pct * 100) + '%)';
        }
        var tot = document.getElementById('qvTotal'); if (tot) tot.textContent = money(c.total) + ' MXN';
        var vn = document.getElementById('qvVolNow'); if (vn) vn.textContent = 'Tu descuento actual: ' + Math.round(c.pct * 100) + '%';
        document.querySelectorAll('#qvVolTiers .vol-tier').forEach(function(el){
          var tier = parseInt(el.getAttribute('data-tier'), 10);
          var active = (c.pct === 0 && tier === 0) || (c.pct === 0.05 && tier === 5) || (c.pct === 0.10 && tier === 10) || (c.pct === 0.15 && tier === 15);
          el.classList.toggle('active', active);
        });
        var add = document.getElementById('qvAdd');
        if (add) add.textContent = 'Agregar al carrito · ' + money(c.total) + ' MXN';
      }
      function qvPickSize(i){ qv.sizeIdx = i; renderQV(); }
      function qvPickColor(c){ qv.color = c; renderQV(); }
      function qvPickColor2(c){ qv.color2 = c; renderQV(); }
      function qvChangeQty(d){ qv.qty = Math.max(1, Math.min(9999, (qv.qty || 1) + d)); renderQV(); }
      // Cantidad tecleada: acepta dígitos, ignora vacío mientras se teclea (se corrige al salir).
      function qvSetQty(raw){
        var s = String(raw == null ? '' : raw).trim();
        if (s.charAt(0) === '-') return false; // negativo: no actualizar; al salir se corrige a 1
        var digits = s.replace(/[^0-9]/g, '');
        if (!digits) return false;
        var n = parseInt(digits, 10);
        if (isNaN(n)) return false;
        qv.qty = Math.max(1, Math.min(9999, n));
        renderQV();
        return true;
      }
      function qvCommitQty(){
        var qEl = document.getElementById('qvQty');
        if (!qEl) return;
        var s = String(qEl.value == null ? '' : qEl.value).trim();
        if (s.charAt(0) === '-'){ qv.qty = 1; renderQV(); return; }
        var digits = s.replace(/[^0-9]/g, '');
        var n = digits ? parseInt(digits, 10) : NaN;
        if (isNaN(n) || n < 1) qv.qty = 1;
        else qv.qty = Math.max(1, Math.min(9999, n));
        renderQV();
      }
      function qvAddToCart(){
        var p = qvProduct(); if (!p) return;
        var c = trendCalc(p);
        var textEl = document.getElementById('qvText');
        var customText = (p.customText && textEl) ? textEl.value.trim() : '';
        var props = {'Tipo': 'Tendencia', 'Producto': p.name, 'Color': qv.color, 'Precio unitario': String(Math.round(c.discUnit * 100) / 100), 'Cantidad': String(c.qty), 'Descuento por volumen': c.pct > 0 ? (Math.round(c.pct * 100) + '% (-' + money(c.disc) + ')') : '0%'};
        if (p.sizes) props['Tamaño'] = p.sizes[qv.sizeIdx].label;
        if (p.dual) props['Color 2'] = qv.color2;
        if (customText) props['Texto personalizado'] = customText;
        var btn = document.getElementById('qvAdd');
        var orig = btn ? btn.textContent : '';
        if (btn){ btn.disabled = true; btn.textContent = 'Agregando…'; }
        fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: CUSTOM_VARIANT_ID, quantity: Math.max(1, Math.round(c.total)), properties: props}]})})
          .then(function(r){ if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function(){ closeQuick(); return refreshCart(true); })
          .then(function(){ if (btn){ btn.disabled = false; btn.textContent = orig; } toast('Agregado al carrito: ' + p.name); })
          .catch(function(){ if (btn){ btn.disabled = false; btn.textContent = orig; } toast('No pudimos agregarlo, intenta de nuevo'); });
      }
      (function(){
        var close = document.getElementById('qvClose');
        if (close) close.addEventListener('click', closeQuick);
        var ov = document.getElementById('qvOverlay');
        if (ov) ov.addEventListener('click', closeQuick);
        var minus = document.getElementById('qvMinus');
        if (minus) minus.addEventListener('click', function(){ qvChangeQty(-1); });
        var plus = document.getElementById('qvPlus');
        if (plus) plus.addEventListener('click', function(){ qvChangeQty(1); });
        var qtyInput = document.getElementById('qvQty');
        if (qtyInput){
          qtyInput.addEventListener('input', function(){ qvSetQty(qtyInput.value); });
          qtyInput.addEventListener('change', function(){ qvCommitQty(); });
          qtyInput.addEventListener('blur', function(){ qvCommitQty(); });
        }
        var add = document.getElementById('qvAdd');
        if (add) add.addEventListener('click', qvAddToCart);
        var gal = document.getElementById('qvGallery');
        if (gal){
          gal.addEventListener('mouseenter', function(){ stopQvRot(); });
          gal.addEventListener('mouseleave', function(){ startQvRot(); });
        }
        document.addEventListener('keydown', function(e){ if (e.key === 'Escape'){ var w = document.getElementById('qvWrap'); if (w && !w.hidden) closeQuick(); } });
      })();
      /* ============ explorador de materiales ============ */
      var MAT_VIEW = {
        pla:    {name:'PLA',          img:'https://cdn.shopify.com/s/files/1/1017/3041/9051/files/img_003.jpg?v=1792082909',    short:'Decoración y prototipos', desc:'El material de diario: con buen detalle y acabado limpio. Es rígido, pero no es amigo del calor fuerte ni del sol directo prolongado.', best:'Figuras, decoración, prototipos y piezas de interior.'},
        petg:   {name:'PETG',         img:'https://cdn.shopify.com/s/files/1/1017/3041/9051/files/img_012.jpg?v=1792083097',   short:'Funcional y de exterior', desc:'Más resistente que el PLA y aguanta humedad y exterior. Es el favorito para piezas que sí van a trabajar y durar.', best:'Soportes, piezas funcionales, macetas y uso en exterior.'},
        tpu95:  {name:'TPU 95A',      img:'https://cdn.shopify.com/s/files/1/1017/3041/9051/files/img_013.jpg?v=1792083107',  short:'Flexible tipo goma', desc:'Flexible y muy difícil de romper: se dobla, absorbe golpes y recupera su forma, con un tacto parecido a goma firme.', best:'Fundas, sellos, topes, ruedas y protectores contra golpes.'},
        tpu64:  {name:'TPU 64D–75D',  img:'https://cdn.shopify.com/s/files/1/1017/3041/9051/files/img_014.jpg?v=1792083118',  short:'Flexible con más cuerpo', desc:'La versión más rígida de los TPU: flexa menos que el 95A y da piezas flexibles con más estructura y resistencia al desgaste.', best:'Protectores firmes, ruedas y piezas flexibles que cargan peso.'},
        placf:  {name:'PLA-CF',       img:'https://cdn.shopify.com/s/files/1/1017/3041/9051/files/img_015.jpg?v=1792083126',  short:'Fibra de carbono, mate', desc:'PLA reforzado con fibra de carbono: más rígido y ligero que el PLA normal, con un acabado mate oscuro muy premium.', best:'Piezas técnicas ligeras, soportes rígidos y prototipos de alta rigidez.'},
        petgcf: {name:'PETG-CF',      img:'https://cdn.shopify.com/s/files/1/1017/3041/9051/files/img_016.jpg?v=1792083135', short:'Fibra de carbono + exterior', desc:'PETG con fibra de carbono: junta la resistencia y el aguante a exterior del PETG con más rigidez y el acabado mate de la fibra.', best:'Piezas funcionales exigentes, mecánicas y de exterior.'}
      };
      var selMat = 'pla';
      function renderMats(){
        var matListEl = document.getElementById('matList');
        var matViewEl = document.getElementById('matView');
        if (!matListEl || !matViewEl) return;
        matListEl.innerHTML = Object.keys(MAT_VIEW).map(function(k){
          var m = MAT_VIEW[k];
          return '<button type="button" class="mat-item' + (selMat === k ? ' sel' : '') + '" onclick="pickMaterial(\'' + k + '\')" aria-pressed="' + (selMat === k) + '"><b>' + m.name + '</b><span>' + m.short + '</span></button>';
        }).join('');
        var m = MAT_VIEW[selMat];
        matViewEl.innerHTML =
          '<img src="' + m.img + '" alt="Material ' + m.name + '" loading="lazy" />' +
          '<div class="mv-body"><h3>' + m.name + '</h3><p>' + m.desc + '</p>' +
          '<p class="mv-best"><b>Ideal para:</b> ' + m.best + '</p>' +
          '<button type="button" class="btn sm" onclick="quoteInMaterial(\'' + selMat + '\')">Cotizar en ' + m.name + ' →</button></div>';
      }
      function pickMaterial(k){ selMat = k; renderMats(); }
      function quoteInMaterial(k){
        location.href = '/pages/cotizar?mat=' + encodeURIComponent(k);
      }

      function renderProducts(){
        var trendEl = document.getElementById('trendGrid');
        if (trendEl) trendEl.innerHTML = TREND_PRODUCTS.map(function(p){ return productCard(p, true); }).join('');
      }
      /* ============ rotación automática de fotos (3s) ============ */
      var cardRotTimers = {}, cardRotIdx = {}, qvRotTimer = null;
      function cardRotAdvance(id){
        var p = TREND_PRODUCTS.filter(function(x){ return x.id === id; })[0];
        if (!p || !p.imgs || p.imgs.length <= 1) return;
        var img = document.querySelector('.ph[data-card-id="' + id + '"] img');
        if (!img) return;
        var next = ((cardRotIdx[id] || 0) + 1) % p.imgs.length;
        cardRotIdx[id] = next;
        img.src = p.imgs[next];
        img.setAttribute('data-idx', String(next));
      }
      function startCardRot(id){
        if (REDUCED) return;
        var p = TREND_PRODUCTS.filter(function(x){ return x.id === id; })[0];
        if (!p || !p.imgs || p.imgs.length <= 1) return;
        if (!document.querySelector('.ph[data-card-id="' + id + '"]')) return;
        stopCardRot(id);
        cardRotTimers[id] = setInterval(function(){ cardRotAdvance(id); }, 3000);
      }
      function stopCardRot(id){
        if (cardRotTimers[id]){ clearInterval(cardRotTimers[id]); cardRotTimers[id] = null; }
      }
      function startAllCardRot(){
        if (REDUCED) return;
        if (!document.getElementById('trendGrid')) return;
        TREND_PRODUCTS.forEach(function(p){ startCardRot(p.id); });
      }
      function stopAllCardRot(){
        TREND_PRODUCTS.forEach(function(p){ stopCardRot(p.id); });
      }
      function startQvRot(){
        stopQvRot();
        if (REDUCED) return;
        var w = document.getElementById('qvWrap');
        if (!w || w.hidden) return;
        var p = qvProduct(); if (!p || !p.imgs || p.imgs.length <= 1) return;
        qvRotTimer = setInterval(function(){
          var pp = qvProduct(); if (!pp) return;
          qvSetImg((qv.imgIdx + 1) % pp.imgs.length);
        }, 3000);
      }
      function stopQvRot(){
        if (qvRotTimer){ clearInterval(qvRotTimer); qvRotTimer = null; }
      }
      function qvManualImg(i){
        qvSetImg(i);
        startQvRot();
      }
      /* ============ carrito ============ */
      var FREE_SHIP_MIN = 899, SHIP_FLAT = 69;
      var lastCart = null;
      function escapeHtml(s){
        return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
          return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
        });
      }
      function cartLineIsTrend(item){
        var props = item.properties || {};
        return props['Tipo'] === 'Tendencia';
      }
      function cartLineIsCustom(item){
        var props = item.properties || {};
        return props['Tipo'] === 'Personalizado';
      }
      function cartLineUnitPrice(item){
        var props = item.properties || {};
        if (cartLineIsTrend(item) && props['Precio unitario']) return parseFloat(props['Precio unitario']) || 0;
        if (cartLineIsCustom(item) && props['Precio total']) return parseFloat(props['Precio total']) || 0;
        return item.price / 100;
      }
      function cartLineRealQty(item){
        if (cartLineIsCustom(item)) return 1;
        var props = item.properties || {};
        if (cartLineIsTrend(item) && props['Precio unitario']){
          var unit = parseFloat(props['Precio unitario']) || 0;
          if (unit > 0) return Math.max(1, Math.round(item.quantity / unit));
        }
        return item.quantity;
      }
      function cartLineTitle(item){
        var props = item.properties || {};
        if (cartLineIsTrend(item) && props['Producto']) return props['Producto'];
        return item.product_title || item.title || '';
      }
      function cartLineSubtitle(item){
        var props = item.properties || {};
        if (cartLineIsCustom(item)){
          var pieces = props['Cantidad'] ? props['Cantidad'] + (props['Cantidad'] === '1' ? ' pieza' : ' piezas') + ' · ' : '';
          return pieces + (props['Pago'] || '');
        }
        if (cartLineIsTrend(item)){
          var parts = [];
          if (props['Tamaño']) parts.push(props['Tamaño']);
          if (props['Color']) parts.push(props['Color']);
          if (props['Color 2']) parts.push('2do: ' + props['Color 2']);
          if (props['Texto personalizado']) parts.push('Texto: ' + props['Texto personalizado']);
          return parts.join(' · ');
        }
        if (props['Color']) return props['Color'];
        return (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      }
      function openCart(){
        var d = document.getElementById('cartDrawer');
        var o = document.getElementById('cartOverlay');
        if (d) d.classList.add('show');
        if (o) o.classList.add('show');
        document.body.classList.add('cart-open');
      }
      function closeCart(){
        var d = document.getElementById('cartDrawer');
        var o = document.getElementById('cartOverlay');
        if (d) d.classList.remove('show');
        if (o) o.classList.remove('show');
        document.body.classList.remove('cart-open');
      }
      function refreshCart(open){
        return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
          lastCart = cart;
          var countEl = document.getElementById('cartCount');
          var itemsEl = document.getElementById('cartItems');
          var emptyEl = document.getElementById('cartEmpty');
          var footEl = document.getElementById('cartFoot');
          var totalQty = 0;
          (cart.items || []).forEach(function(it){ totalQty += cartLineRealQty(it); });
          if (countEl){ countEl.textContent = totalQty; countEl.hidden = totalQty === 0; }
          if (itemsEl){
            if (!cart.items || !cart.items.length){
              itemsEl.innerHTML = '';
              if (emptyEl) emptyEl.hidden = false;
              if (footEl) footEl.hidden = true;
            } else {
              if (emptyEl) emptyEl.hidden = true;
              if (footEl) footEl.hidden = false;
              itemsEl.innerHTML = cart.items.map(function(it){
                var q = cartLineRealQty(it), unit = cartLineUnitPrice(it);
                var qtyHtml = cartLineIsCustom(it)
                  ? '<span class="ci-single">1 pedido</span>'
                  : '<div class="ci-qty"><button type="button" onclick="cartChangeQty(\'' + it.key + '\',-1)" aria-label="Quitar uno">−</button>' +
                    '<span>' + q + '</span>' +
                    '<button type="button" onclick="cartChangeQty(\'' + it.key + '\',1)" aria-label="Agregar uno">+</button></div>';
                return '<div class="cart-item">' +
                  (it.image ? '<img src="' + it.image + '" alt="" />' : '<span class="ci-noimg"></span>') +
                  '<div class="ci-body"><b>' + escapeHtml(cartLineTitle(it)) + '</b>' +
                  (cartLineSubtitle(it) ? '<span>' + escapeHtml(cartLineSubtitle(it)) + '</span>' : '') +
                  '<span class="ci-price">' + money(unit) + ' MXN</span></div>' +
                  qtyHtml +
                  '<button type="button" class="ci-remove" onclick="cartChange(\'' + it.key + '\',0)" aria-label="Eliminar">×</button></div>';
              }).join('');
            }
          }
          var sub = cart.total_price / 100;
          var ship = sub >= FREE_SHIP_MIN ? 0 : (sub > 0 ? SHIP_FLAT : 0);
          var stEl = document.getElementById('cartSubtotal');
          var shEl = document.getElementById('cartShip');
          var ttEl = document.getElementById('cartTotal');
          var progEl = document.getElementById('cartShipMsg');
          var barEl = document.getElementById('cartShipBar');
          if (stEl) stEl.textContent = money(sub) + ' MXN';
          if (shEl) shEl.textContent = sub > 0 ? (ship === 0 ? 'Gratis' : money(ship) + ' MXN') : '—';
          if (ttEl) ttEl.textContent = money(sub + ship) + ' MXN';
          if (progEl){
            if (sub <= 0) progEl.textContent = 'Tu carrito está vacío.';
            else if (ship === 0) progEl.textContent = '¡Ya tienes envío gratis!';
            else progEl.textContent = 'Te faltan ' + money(FREE_SHIP_MIN - sub) + ' MXN para envío gratis.';
          }
          if (barEl) barEl.style.width = Math.min(100, (sub / FREE_SHIP_MIN) * 100) + '%';
          if (open) openCart();
          return cart;
        }).catch(function(){});
      }
      function cartChange(key, qty){
        fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: key, quantity: qty})})
          .then(function(){ return refreshCart(false); });
      }
      function cartChangeQty(key, delta){
        if (!lastCart) return;
        var it = (lastCart.items || []).filter(function(x){ return x.key === key; })[0];
        if (!it) return;
        var props = it.properties || {};
        var step = (cartLineIsTrend(it) && props['Precio unitario']) ? (parseFloat(props['Precio unitario']) || 1) : 1;
        cartChange(key, Math.max(0, Math.round(it.quantity + delta * step)));
      }
      function buyProduct(id){ openQuick(id); }

      /* ============ toast + copy ============ */
      var toastTimer;
      function toast(msg){
        var t = document.getElementById('toast');
        t.textContent = msg; t.classList.add('show');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 2600);
      }
      function copyText(txt, msg){
        function done(){ toast(msg || 'Copiado ✓'); }
        if (navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(txt).then(done).catch(function(){ fallback(); });
        } else fallback();
        function fallback(){
          var ta = document.createElement('textarea');
          ta.value = txt; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); done(); } catch(e){ toast('Copia el texto manualmente'); }
          document.body.removeChild(ta);
        }
      }

      /* ============ cotizador ============ */
      var stlVolumeCm3 = null;
                  var designNoteClosed = false;
      function closeDesignNote(){
        designNoteClosed = true;
        var dn = document.getElementById('designNote');
        if (!dn) return;
        dn.classList.remove('show');
        dn.classList.add('gone');
      }
      function closeApartadoNote(){
        var an = document.getElementById('apartadoNote');
        if (!an) return;
        an.classList.remove('show');
        an.classList.add('gone');
      }
      function calcTouch(){ calc(); }
      function num(id, d){ var v = parseFloat(document.getElementById(id).value); return isNaN(v) ? d : v; }

      function calcStl(){
        var mat = MATERIALS[document.getElementById('matStl').value];
        var infill = num('infill', 20) / 100;
        var layerH = parseFloat(document.getElementById('quality').value);
        var qty = Math.max(1, Math.round(num('qtyStl', 1)));
        var volCm3;
        if (stlVolumeCm3 !== null){
          volCm3 = stlVolumeCm3;
        } else {
          var x = num('dimX', 0), y = num('dimY', 0), z = num('dimZ', 0);
          volCm3 = (x * y * z / 1000) * parseFloat(document.getElementById('solidity').value);
        }
        var effVol = volCm3 * (0.22 + 0.78 * Math.max(infill, 0.05));
        var weight = effVol * mat.density; // g por pieza
        var speed = layerH <= 0.13 ? 32 : (layerH <= 0.21 ? 45 : 55);
        var flow = layerH * 0.45 * speed; // mm3/s
        var hours = (effVol * 1000) / flow / 3600;
        hours = Math.max(hours, 0.25);
        var cFil = weight * (mat.priceKg / 1000) * qty;
        var cMach = hours * MACHINE_RATE * qty;
        var subtotal = cFil + cMach + PREP_FEE;
        var total = subtotal * MARGIN;
        var lines = [
          ['Material · ' + mat.name + ' (' + Math.round(weight) + ' g/pieza)', cFil * MARGIN],
          ['Tiempo de impresión · ' + hours.toFixed(1) + ' h/pieza', cMach * MARGIN],
          ['Preparación del pedido', PREP_FEE * MARGIN]
        ];
        return {
          lines: lines,
          total: total, per: total / qty,
          label: qty > 1 ? 'por pieza' : ''
        };
      }

      function volumeDiscountPct(qty){ if (qty >= 50) return 0.15; if (qty >= 25) return 0.10; if (qty >= 5) return 0.05; return 0; }
      function computeDiscounts(baseTotal){
        var qty = Math.max(1, Math.round(num('qtyStl', 1)));
        var volPct = volumeDiscountPct(qty);
        var volAmt = Math.round(baseTotal * volPct);
        var afterVol = baseTotal - volAmt;
        var nf = document.getElementById('noFactura');
        var noFacAmt = (nf && nf.checked) ? Math.round(afterVol * 0.05) : 0;
        var finalTotal = afterVol - noFacAmt;
        return {qty: qty, volPct: volPct, volAmt: volAmt, afterVol: afterVol, noFacAmt: noFacAmt, finalTotal: finalTotal};
      }
      function updateVolTable(d){
        var now = document.getElementById('volNow');
        if (now) now.textContent = 'Tu descuento actual: ' + Math.round(d.volPct * 100) + '%';
        document.querySelectorAll('#volTiers .vol-tier').forEach(function(el){
          var tier = parseInt(el.getAttribute('data-tier'), 10);
          var active = (d.volPct === 0 && tier === 0) || (d.volPct === 0.05 && tier === 5) || (d.volPct === 0.10 && tier === 10) || (d.volPct === 0.15 && tier === 15);
          el.classList.toggle('active', active);
        });
      }
      function updateApartadoCard(finalTotal){
        var card = document.getElementById('apartado3000Card');
        if (!card) return;
        if (!(finalTotal > 3000)){ card.hidden = true; return; }
        card.hidden = false;
        var hoy = Math.round(finalTotal * 0.25), resto = finalTotal - hoy;
        var hoyEl = document.getElementById('apartadoHoy'); if (hoyEl) hoyEl.textContent = money(hoy);
        var restoEl = document.getElementById('apartadoResto'); if (restoEl) restoEl.textContent = money(resto);
        var totEl = document.getElementById('apartadoTotal'); if (totEl) totEl.textContent = money(finalTotal);
      }
      function calc(){
        var r = calcStl();
        var d = computeDiscounts(r.total);
        var allLines = r.lines.slice();
        if (d.volPct > 0) allLines.push(['Descuento por volumen (' + Math.round(d.volPct * 100) + '%)', -d.volAmt, '-' + money(d.volAmt)]);
        if (d.noFacAmt > 0) allLines.push(['Descuento sin factura (5%)', -d.noFacAmt, '-' + money(d.noFacAmt)]);
        var html = allLines.map(function(l){
          var val = l[2] !== undefined ? l[2] : money(l[1]);
          return '<div class="row"><span>' + l[0] + '</span><b>' + val + '</b></div>';
        }).join('');
        document.getElementById('sumLines').innerHTML = html;
        document.getElementById('sumTotal').textContent = money(d.finalTotal);
        document.getElementById('sumPer').textContent = r.label ? r.label : '';
        lastQuote = {lines: r.lines, total: r.total, baseTotal: r.total, per: d.finalTotal / d.qty, label: r.label, volPct: d.volPct, volAmt: d.volAmt, noFacAmt: d.noFacAmt, finalTotal: d.finalTotal, qty: d.qty};
        updatePayUI();
      }
      var lastQuote = null;


      function copyContact(){
        var name = document.getElementById('cName').value.trim();
        var contact = document.getElementById('cContact').value.trim();
        var type = document.getElementById('cType').value;
        var msg = document.getElementById('cMsg').value.trim();
        if (!msg && !name){ toast('Escribe al menos tu mensaje'); return; }
        var out = 'MENSAJE — IMPRESIÓN 3D\nNombre: ' + (name || '—') + '\nContacto: ' + (contact || '—') + '\nTipo: ' + type + '\n\n' + msg;
        copyText(out, 'Mensaje copiado ✓ Envíalo por tu canal preferido');
      }

      /* ============ STL parsing ============ */
      function parseSTL(buffer){
        var dv = new DataView(buffer);
        var isAscii = false;
        if (buffer.byteLength >= 5){
          var head = new TextDecoder().decode(buffer.slice(0, 5)).toLowerCase();
          if (head === 'solid'){
            // puede ser binario que empieza con "solid"; verificar tamaño esperado
            var n = dv.getUint32(80, true);
            if (84 + n * 50 !== buffer.byteLength) isAscii = true;
          }
        }
        var tris = [];
        if (isAscii){
          var text = new TextDecoder().decode(buffer);
          var verts = [];
          var re = /vertex\s+([-\d.eE+]+)\s+([-\d.eE+]+)\s+([-\d.eE+]+)/g, m;
          while ((m = re.exec(text)) !== null) verts.push([parseFloat(m[1]), parseFloat(m[2]), parseFloat(m[3])]);
          for (var i = 0; i + 2 < verts.length; i += 3) tris.push([verts[i], verts[i+1], verts[i+2]]);
        } else {
          var count = dv.getUint32(80, true);
          var off = 84;
          for (var j = 0; j < count; j++){
            var t = [];
            for (var k = 0; k < 3; k++){
              var base = off + 12 + k * 12;
              t.push([dv.getFloat32(base, true), dv.getFloat32(base + 4, true), dv.getFloat32(base + 8, true)]);
            }
            tris.push(t);
            off += 50;
          }
        }
        var vol = 0, min = [1e9,1e9,1e9], max = [-1e9,-1e9,-1e9];
        tris.forEach(function(t){
          var a = t[0], b = t[1], c = t[2];
          vol += (a[0] * (b[1] * c[2] - c[1] * b[2]) - a[1] * (b[0] * c[2] - c[0] * b[2]) + a[2] * (b[0] * c[1] - c[0] * b[1])) / 6;
          t.forEach(function(v){
            for (var d = 0; d < 3; d++){ if (v[d] < min[d]) min[d] = v[d]; if (v[d] > max[d]) max[d] = v[d]; }
          });
        });
        return { volumeCm3: Math.abs(vol) / 1000, dims: [max[0]-min[0], max[1]-min[1], max[2]-min[2]], triangles: tris.length, tris: tris, bounds: {min: min, max: max} };
      }

      var drop = document.getElementById('dropZone');
      var fileInput = document.getElementById('stlFile');
      if (drop && fileInput){
        drop.addEventListener('click', function(){ fileInput.click(); });
        drop.addEventListener('dragover', function(e){ e.preventDefault(); drop.classList.add('over'); });
        drop.addEventListener('dragleave', function(){ drop.classList.remove('over'); });
        drop.addEventListener('drop', function(e){
          e.preventDefault(); drop.classList.remove('over');
          if (e.dataTransfer.files.length) handleSTL(e.dataTransfer.files[0]);
        });
        fileInput.addEventListener('change', function(){ if (fileInput.files.length) handleSTL(fileInput.files[0]); });
      }

      function handleSTL(file){
        if (!/\.stl$/i.test(file.name)){ toast('Ese archivo no es .STL'); return; }
        file.arrayBuffer().then(function(buf){
          try {
            var r = parseSTL(buf);
            stlVolumeCm3 = r.volumeCm3;
            document.getElementById('dimX').value = Math.round(r.dims[0]);
            document.getElementById('dimY').value = Math.round(r.dims[1]);
            document.getElementById('dimZ').value = Math.round(r.dims[2]);
            stlFileName = file.name;
            stlPreviewTris = decimateTris(r.tris);
            pvCenter = [(r.bounds.min[0] + r.bounds.max[0]) / 2, (r.bounds.min[1] + r.bounds.max[1]) / 2, (r.bounds.min[2] + r.bounds.max[2]) / 2];
            pvScale = (Math.min(640, 480) * 0.38) / (Math.max(r.dims[0], r.dims[1], r.dims[2]) / 2 || 1);
            document.getElementById('stlInfo').innerHTML =
              '<b>' + file.name + '</b><br /><span class="mono">' + Math.round(r.dims[0]) + ' × ' + Math.round(r.dims[1]) + ' × ' + Math.round(r.dims[2]) + ' mm</span>';
            var psn = document.getElementById('payStlNote');
            if (psn) psn.hidden = false;
            startSTLPreview();
            document.getElementById('stlInfo').classList.add('show');
            calcTouch();
            toast('STL leído ✓ Cotización actualizada');
          } catch(e){ toast('No pudimos leer ese STL'); }
        });
      }

      /* ============ wiring ============ */
      ['dimX','dimY','dimZ','solidity','matStl','quality','qtyStl'].forEach(function(id){
        var el = document.getElementById(id);
        if (!el) return;
        el.addEventListener('input', function(){
          if (id !== 'dimX' && id !== 'dimY' && id !== 'dimZ') { /* dimensión manual ya no usa STL */ }
          calcTouch();
        });
        el.addEventListener('change', calcTouch);
      });
      // Al editar medidas a mano se deja de usar el volumen del STL
      ['dimX','dimY','dimZ'].forEach(function(id){
        var dEl = document.getElementById(id);
        if (dEl) dEl.addEventListener('input', function(){ stlVolumeCm3 = null; });
      });
      var infillEl = document.getElementById('infill');
      if (infillEl) infillEl.addEventListener('input', function(){
        document.getElementById('infillOut').textContent = this.value + '%';
        calcTouch();
      });

      [['designNoteClose', closeDesignNote],['apartadoNoteClose', closeApartadoNote]].forEach(function(pair){
        var bEl = document.getElementById(pair[0]);
        if (bEl) bEl.addEventListener('click', pair[1]);
      });


      /* Inicialización protegida. */
      try { renderMats(); } catch (e) { if (window.console) console.error('renderMats', e); }
      try { renderProducts(); } catch (e) { if (window.console) console.error('renderProducts', e); }
      /* Rotación de tarjetas: pausa al pasar el mouse / al enfocar, reanuda al salir. */
      (function(){
        var grid = document.getElementById('trendGrid');
        if (grid){
          grid.addEventListener('mouseover', function(e){
            var ph = e.target.closest ? e.target.closest('.ph[data-card-id]') : null;
            if (ph) stopCardRot(ph.getAttribute('data-card-id'));
          });
          grid.addEventListener('mouseout', function(e){
            var ph = e.target.closest ? e.target.closest('.ph[data-card-id]') : null;
            if (ph && (!e.relatedTarget || !ph.contains(e.relatedTarget))) startCardRot(ph.getAttribute('data-card-id'));
          });
          grid.addEventListener('focusin', function(e){
            var ph = e.target.closest ? e.target.closest('.ph[data-card-id]') : null;
            if (ph) stopCardRot(ph.getAttribute('data-card-id'));
          });
          grid.addEventListener('focusout', function(e){
            var ph = e.target.closest ? e.target.closest('.ph[data-card-id]') : null;
            if (ph && (!e.relatedTarget || !ph.contains(e.relatedTarget))) startCardRot(ph.getAttribute('data-card-id'));
          });
        }
      })();
      try { startAllCardRot(); } catch (e) { if (window.console) console.error('startAllCardRot', e); }
      try { calc(); } catch (e) {}
      /* Material preseleccionado al llegar desde Inicio ("Cotizar en X"). */
      (function(){
        var m = document.getElementById('matStl');
        if (!m) return;
        try {
          var q = new URLSearchParams(location.search).get('mat');
          if (q && MATERIALS[q]) m.value = q;
        } catch(e){}
      })();

      /* ============ vista previa 3D del STL ============ */
      var stlPreviewTris = null, stlFileName = '';
      var pvCenter = [0, 0, 0], pvScale = 1, pvRotY = 0.7, pvRotX = -0.4;
      var pvRaf = null, pvDragging = false, pvLastX = 0, pvLastY = 0, pvFrame = 0;
      function decimateTris(tris){
        if (!tris || tris.length <= 5000) return tris;
        var step = Math.ceil(tris.length / 5000), out = [];
        for (var i = 0; i < tris.length; i += step) out.push(tris[i]);
        return out;
      }
      function renderSTLPreview(){
        var cv = document.getElementById('stlPreview');
        if (!cv || !stlPreviewTris) return;
        var ctx = cv.getContext('2d');
        var W = cv.width, H = cv.height;
        ctx.clearRect(0, 0, W, H);
        var cy = Math.cos(pvRotY), sy = Math.sin(pvRotY);
        var cx = Math.cos(pvRotX), sx = Math.sin(pvRotX);
        function proj(v){
          var x = v[0] - pvCenter[0], y = v[1] - pvCenter[1], z = v[2] - pvCenter[2];
          var x1 = x * cy + z * sy, z1 = -x * sy + z * cy;
          var y1 = y * cx - z1 * sx, z2 = y * sx + z1 * cx;
          return [W / 2 + x1 * pvScale, H / 2 - y1 * pvScale, z2];
        }
        var items = [];
        for (var i = 0; i < stlPreviewTris.length; i++){
          var t = stlPreviewTris[i];
          var a = proj(t[0]), b = proj(t[1]), c = proj(t[2]);
          var e1x = t[1][0]-t[0][0], e1y = t[1][1]-t[0][1], e1z = t[1][2]-t[0][2];
          var e2x = t[2][0]-t[0][0], e2y = t[2][1]-t[0][1], e2z = t[2][2]-t[0][2];
          var nx = e1y*e2z - e1z*e2y, ny = e1z*e2x - e1x*e2z, nz = e1x*e2y - e1y*e2x;
          var nl = Math.sqrt(nx*nx + ny*ny + nz*nz) || 1;
          var nnx = nx*cy + nz*sy, nnz = -nx*sy + nz*cy;
          var nny = ny*cx - nnz*sx, nnzz = ny*sx + nnz*cx;
          var shade = 0.45 + 0.55 * Math.max(0, (nnx*0.4 + nny*0.6 + nnzz*0.7) / nl);
          items.push({a:a, b:b, c:c, z:(a[2]+b[2]+c[2])/3, s:shade});
        }
        items.sort(function(p, q){ return q.z - p.z; });
        for (var j = 0; j < items.length; j++){
          var it = items[j];
          ctx.beginPath();
          ctx.moveTo(it.a[0], it.a[1]); ctx.lineTo(it.b[0], it.b[1]); ctx.lineTo(it.c[0], it.c[1]); ctx.closePath();
          ctx.fillStyle = 'rgb(' + Math.round(232*it.s) + ',' + Math.round(90*it.s) + ',' + Math.round(23*it.s) + ')';
          ctx.fill();
        }
      }
      function pvLoop(){
        if (!stlPreviewTris) return;
        pvFrame++;
        if (!pvDragging && !REDUCED) pvRotY += 0.008;
        if (pvFrame % 2 === 0) renderSTLPreview();
        pvRaf = requestAnimationFrame(pvLoop);
      }
      function startSTLPreview(){
        var wrap = document.getElementById('stlPreviewWrap');
        if (wrap) wrap.hidden = false;
        renderSTLPreview();
        var cv = document.getElementById('stlPreview');
        if (cv && !cv.dataset.wired){
          cv.dataset.wired = '1';
          cv.addEventListener('pointerdown', function(e){ pvDragging = true; pvLastX = e.clientX; pvLastY = e.clientY; try { cv.setPointerCapture(e.pointerId); } catch(err){} });
          cv.addEventListener('pointermove', function(e){ if (!pvDragging) return; pvRotY += (e.clientX - pvLastX) * 0.01; pvRotX += (e.clientY - pvLastY) * 0.01; pvRotX = Math.max(-1.2, Math.min(1.2, pvRotX)); pvLastX = e.clientX; pvLastY = e.clientY; renderSTLPreview(); });
          var endDrag = function(){ pvDragging = false; };
          cv.addEventListener('pointerup', endDrag);
          cv.addEventListener('pointercancel', endDrag);
        }
        if (REDUCED){ renderSTLPreview(); return; }
        if (!pvRaf) pvLoop();
      }
      function clearSTL(){
        stlPreviewTris = null;
        stlFileName = '';
        stlVolumeCm3 = null;
        var fi = document.getElementById('stlFile');
        if (fi) fi.value = '';
        var info = document.getElementById('stlInfo');
        if (info){ info.innerHTML = ''; info.classList.remove('show'); }
        var wrap = document.getElementById('stlPreviewWrap');
        if (wrap) wrap.hidden = true;
        var cv = document.getElementById('stlPreview');
        if (cv){ var cx2 = cv.getContext('2d'); cx2.clearRect(0, 0, cv.width, cv.height); }
        if (pvRaf){ cancelAnimationFrame(pvRaf); pvRaf = null; }
        var psn = document.getElementById('payStlNote');
        if (psn) psn.hidden = true;
        calcTouch();
      }
      (function(){
        var btn = document.getElementById('stlClear');
        if (btn) btn.addEventListener('click', clearSTL);
      })();

      /* ============ pago directo ============ */
      var CUSTOM_VARIANT_ID = 54083929211243;
      function payAmounts(){
        if (!lastQuote) return {base: 0, finalTotal: 0, deposit: 0, rest: 0, volPct: 0, volAmt: 0, noFacAmt: 0};
        var d = computeDiscounts(lastQuote.baseTotal || lastQuote.total);
        var deposit = Math.round(d.finalTotal * 0.25);
        return {base: d.finalTotal, finalTotal: d.finalTotal, deposit: deposit, rest: d.finalTotal - deposit, volPct: d.volPct, volAmt: d.volAmt, noFacAmt: d.noFacAmt};
      }
      function updatePayUI(){
        var a = payAmounts();
        var pt = document.getElementById('payTotal');
        if (pt) pt.textContent = money(a.base);
        var pf = document.getElementById('payTotalAmt');
        if (pf) pf.textContent = money(a.base);
        updateVolTable({volPct: a.volPct});
        updateApartadoCard(a.base);
      }
      function orderProps(){
        var matSel = document.getElementById('matStl');
        var matName = (matSel && MATERIALS[matSel.value]) ? MATERIALS[matSel.value].name : '';
        var qSel = document.getElementById('quality');
        var sSel = document.getElementById('solidity');
        var nf = document.getElementById('noFactura');
        var colorEl = document.getElementById('colorStl');
        var d = lastQuote ? {volPct: lastQuote.volPct || 0, volAmt: lastQuote.volAmt || 0, noFacAmt: lastQuote.noFacAmt || 0, finalTotal: lastQuote.finalTotal || lastQuote.total, baseTotal: lastQuote.baseTotal || lastQuote.total} : {volPct: 0, volAmt: 0, noFacAmt: 0, finalTotal: 0, baseTotal: 0};
        return {
          'Material': matName,
          'Medidas (mm)': num('dimX', 0) + ' × ' + num('dimY', 0) + ' × ' + num('dimZ', 0),
          'Relleno': num('infill', 20) + '%',
          'Calidad': (qSel && qSel.selectedOptions[0]) ? qSel.selectedOptions[0].text : '',
          'Tipo de pieza': (sSel && sSel.selectedOptions[0]) ? sSel.selectedOptions[0].text : '',
          'Cantidad': Math.max(1, Math.round(num('qtyStl', 1))),
          'Color': (colorEl && colorEl.value.trim()) || 'Sin preferencia',
          'Archivo STL': stlFileName || 'Sin archivo (medidas manuales)',
          'Factura': (nf && nf.checked) ? 'No (descuento 5%)' : 'Sí',
          'Descuento por volumen': d.volPct > 0 ? (Math.round(d.volPct * 100) + '% (-' + money(d.volAmt) + ')') : '0%',
          'Descuento sin factura': d.noFacAmt > 0 ? ('5% (-' + money(d.noFacAmt) + ')') : 'No',
          'Pago': 'Pago completo',
          'Precio cotizado': money(d.finalTotal),
          'Subtotal sin descuentos': money(d.baseTotal)
        };
      }
      function goPay(){
        if (!lastQuote || !(lastQuote.finalTotal > 0)){ toast('Primero arma tu cotización'); return; }
        var a = payAmounts();
        var qty = Math.max(1, Math.round(a.base));
        var btn = document.getElementById('payFullBtn');
        var orig = btn ? btn.innerHTML : '';
        if (btn){ btn.disabled = true; btn.textContent = 'Agregando…'; }
        var props = orderProps();
        props['Tipo'] = 'Personalizado';
        props['Precio total'] = String(qty);
        fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: CUSTOM_VARIANT_ID, quantity: qty, properties: props}]})})
          .then(function(r){ if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function(){ return refreshCart(true); })
          .then(function(){ if (btn){ btn.disabled = false; btn.innerHTML = orig; } toast('Agregado al carrito: tu pieza personalizada'); })
          .catch(function(){ if (btn){ btn.disabled = false; btn.innerHTML = orig; } toast('No pudimos agregarlo, inténtalo de nuevo'); });
      }
      (function(){
        var full = document.getElementById('payFullBtn');
        if (full) full.addEventListener('click', function(){ goPay(); });
        var nf = document.getElementById('noFactura');
        if (nf) nf.addEventListener('change', calcTouch);
      })();

      /* ============ popup acabado / pintura ============ */
      (function(){
        var btn = document.getElementById('finishInfoBtn');
        var pop = document.getElementById('finishPop');
        if (!btn || !pop) return;
        btn.addEventListener('click', function(){ pop.classList.add('show'); });
        var close = document.getElementById('finishPopClose');
        if (close) close.addEventListener('click', function(){ pop.classList.remove('show'); });
      })();

      /* ============ hero video: respetar movimiento reducido ============ */
      (function(){
        if (!REDUCED) return;
        var v = document.getElementById('heroVideo');
        if (v){ v.removeAttribute('autoplay'); v.pause(); }
      })();

      /* ============ carrito: cableado ============ */
      (function(){
        var btn = document.getElementById('cartBtn');
        if (btn) btn.addEventListener('click', function(){ refreshCart(true); });
        var close = document.getElementById('cartClose');
        if (close) close.addEventListener('click', closeCart);
        var ov = document.getElementById('cartOverlay');
        if (ov) ov.addEventListener('click', closeCart);
        var cont = document.getElementById('cartContinue');
        if (cont) cont.addEventListener('click', closeCart);
        document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeCart(); });
        refreshCart(false);
      })();

      /* ============ reveal al hacer scroll ============ */
      (function(){
        if (!('IntersectionObserver' in window)) return;
        var els = document.querySelectorAll('section.block, .hero');
        if (!els.length) return;
        els.forEach(function(el){ el.classList.add('reveal'); });
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
        }, {threshold: 0.1});
        els.forEach(function(el){ io.observe(el); });
      })();
